// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.checkout-button {
  background: rgba(237, 109, 5, 0.8);
  padding: 7px 10px;
  color: #FEFEFE;
  border-radius: 10px;
  font-size: 16px;
}
.payment-badge {
  background: rgba(237, 109, 5, 0.8);
  color: #FEFEFE;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 1px;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 14px;
}
.inline-message {

}
.inline-checkout-button {
  font-size: 16px;
  padding: 5px 10px;
  background: none;
  background: rgba(237, 109, 5, 0.8);
  border-radius: 10px;
  color: #FEFEFE;
  margin-left: 10px;
}
.payment-overlay {
  z-index: 500; display: flex;
  width: 100%; height: 100%;
  position: relative;
}
.blank {
  background: white;
}
.overlay {
  position: absolute;
  top: 200px;
  right: 10px;
  z-index: 600;
  pointer-events: fill;
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 24px;
  letter-spacing: 0.15px;
  background: rgba(237, 109, 5, 0.8);
  border-radius: 10px;
  color: #FEFEFE;
  padding: 0 10px;
}
.blocked {
  
  z-index: 500;
  font-family: Roboto; 
  display: block;  width: 100%; height: 100%;
  flex-direction: column; 
  flex-grow: 1 !important; 
  position: relative;
  border-radius: 8px;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/farmer-devices/farmer-devices.ts"],"names":[],"mappings":";;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;;AAEA;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,WAAW,EAAE,YAAY;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,cAAc,GAAG,WAAW,EAAE,YAAY;EAC1C,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["\n\n.checkout-button {\n  background: rgba(237, 109, 5, 0.8);\n  padding: 7px 10px;\n  color: #FEFEFE;\n  border-radius: 10px;\n  font-size: 16px;\n}\n.payment-badge {\n  background: rgba(237, 109, 5, 0.8);\n  color: #FEFEFE;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  top: 1px;\n  border-radius: 10px;\n  padding: 2px 10px;\n  font-size: 14px;\n}\n.inline-message {\n\n}\n.inline-checkout-button {\n  font-size: 16px;\n  padding: 5px 10px;\n  background: none;\n  background: rgba(237, 109, 5, 0.8);\n  border-radius: 10px;\n  color: #FEFEFE;\n  margin-left: 10px;\n}\n.payment-overlay {\n  z-index: 500; display: flex;\n  width: 100%; height: 100%;\n  position: relative;\n}\n.blank {\n  background: white;\n}\n.overlay {\n  position: absolute;\n  top: 200px;\n  right: 10px;\n  z-index: 600;\n  pointer-events: fill;\n  font-family: 'Ubuntu';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  background: rgba(237, 109, 5, 0.8);\n  border-radius: 10px;\n  color: #FEFEFE;\n  padding: 0 10px;\n}\n.blocked {\n  \n  z-index: 500;\n  font-family: Roboto; \n  display: block;  width: 100%; height: 100%;\n  flex-direction: column; \n  flex-grow: 1 !important; \n  position: relative;\n  border-radius: 8px;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
